import { render, staticRenderFns } from "./UEditor.vue?vue&type=template&id=a779a6d6&scoped=true"
import script from "./UEditor.vue?vue&type=script&lang=js"
export * from "./UEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a779a6d6",
  null
  
)

export default component.exports